<template>
  <div
    class="banner d-flex flex-column justify-content-center align-items-center position-relative"
  >
    <video
      autoplay
      muted
      playsinline
      ref="bannerVideo"
      @ended="restartVideo"
      class="bg-video position-absolute w-100 h-100 top-50 start-50 translate-middle"
    >
      <source src="@/assets/video/home_banner.mp4" type="video/mp4" />
    </video>
    <img
      src="@/assets/image/banner title.png"
      alt="banner-logo"
      class="logo"
    />
    <h2 class="text-light text-center mt-4 fs-1">
      無界創新、未來企業的數位日常
    </h2>
    <p class="rounded-pill blue-gradient text-light px-3 py-2 mt-4">
      <!-- 2024.6.3 - 7.19 -->
      精彩回放，立即登入
    </p>
    <div
      class="progress-bar d-flex flex-row justify-content-between position-absolute bottom-0 mb-5"
    >
      <div class="w-100 h-100 bg-light rounded-3 d-flex justify-content-start">
        <div
          class="bar-filled rounded-3"
          :style="{ width: `${barWidth}%` }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      barWidth: 0,
      intervalId: null,
    };
  },
  mounted() {
    this.fillProgress();
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    fillProgress() {
      this.barWidth = 0;
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        if (this.barWidth < 100) {
          this.barWidth += 1;
        } else {
          clearInterval(this.intervalId);
          this.restartVideo();
        }
      }, 100);
    },
    restartVideo() {
      this.$refs.bannerVideo.play();
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.fillProgress();
    },
  },
};
</script>

<style lang="scss">
.banner {
  overflow: hidden;
  height: 900px;
  letter-spacing: 6px;
  z-index: -2;

  @media(max-width: $md) {
    height: calc(177.9vw * 0.8);
  }

  .logo {
    width: 300px;
    z-index: 0;
  }

  h2 {
    z-index: 0;
  }

  p {
    letter-spacing: 1px;
    z-index: 0;
  }

  .bg-video {
    object-fit: cover;
    z-index: -1;
  }

  .bg-img {
    object-fit: cover;
    z-index: -1;
  }

  .progress-bar {
    z-index: 0;
    height: 5px;
    width: 60px;

    .bar-filled {
      z-index: 1;
      background-color: #27a1d8;
    }
  }
}
</style>
